import React from 'react';

export const pushListingIntoGtm = (payload,) => {
    if (typeof window.dataLayer != 'object') {
        return;
    }
    window.dataLayer.push({
        event: 'RT_event',
        'Destination City id': payload.source,
        'Origin City Id': payload.destination,
        'Origin City Name': payload.sourceStation,
        'Destination City Name': payload.destinationStation,
        'Travel Date': payload.doj,
        'pageType': 'listing',
        AP: getAdvancePurchaseDays(payload.doj),
    });
};

export const pushPnrStatusIntoGtm = (payload,) => {
    if (typeof window.dataLayer == 'object') {
        console.log(
            `data pushed to GTM for pnr status`
        );
        window.dataLayer.push({
            event: 'RT_event',
            'Destination City id': payload.source,
            'Origin City Id': payload.destination,
            'Origin City Name': payload.sourceStation,
            'Destination City Name': payload.destinationStation,
            'Travel Date': payload.depDate,
            'Departure Date': payload.depDate,
            'Arrival Date': payload.arrivalDate,
            'Train Type': payload.trainType,
            'Class Type': payload.class,
            'pageType': 'PNR Status Page',
            AP: getAdvancePurchaseDays(payload.depDate),
        });
    }
};



export const pushReviewIntoGtm = (payload,) => {
    const gtmReviewData = {
        event: 'RT_event',
        'pageType': payload.pageType,
        'Destination City id': payload.destination,
        'Origin City Id': payload.source,
        'Origin City Name': payload.sourceStation,
        'Destination City Name': payload.destinationStation,
        'Travel Date': payload.doj,
        'AP': getAdvancePurchaseDays(payload.doj),
        'Price Per Adult': payload.totalFare,
        'Class Type': payload.class,
        'Train Number': payload.trainNumber
    };
    try {
        localStorage.setItem('_GTMReviewData', JSON.stringify(gtmReviewData));
        if (typeof window.dataLayer == 'object') {
            console.log('data pushed to GTM for review');
            window.dataLayer.push(gtmReviewData);
        }
    } catch (error) {
        console.error('Storage access denied')
    }
};


export const getAdvancePurchaseDays = (departDate) => {
    try{
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const oneDay = 24 * 60 * 60 * 1000;
        const diff = departDate ? (departDate.getTime() - today.getTime()) / oneDay : 0;
        return Math.floor(diff);
    }catch (e) {
        return 0;
    }
};
